import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    TranslateModule,
    NgIf
  ],
  template: `
    <div style="display:flex;justify-content:center;align-items:center;min-height:100vh;">
      <mat-card style="width:360px;">
        <h2>{{ 'auth.login' | translate }}</h2>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>{{ 'auth.email' | translate }}</mat-label>
            <input matInput formControlName="email" type="email" required>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>{{ 'auth.password' | translate }}</mat-label>
            <input matInput formControlName="password" type="password" required>
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || loading">
            {{ loading ? ('common.loading' | translate) : ('auth.login' | translate) }}
          </button>
        </form>
      </mat-card>
    </div>
  `
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);
  private snack = inject(MatSnackBar);
  private t = inject(TranslateService);

  loading = false;

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]]
  });

  submit() {
    if (this.form.invalid) return;
    this.loading = true;
    const { email, password } = this.form.value as { email: string; password: string };
    this.auth.login(email, password).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigateByUrl('/');
      },
      error: (err) => {
        this.loading = false;
        const msg = err?.error?.message || this.t.instant('auth.loginFailed');
        this.snack.open(msg, this.t.instant('common.close'), { duration: 3000 });
      }
    });
  }
}

